var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.questionsToShow.length
    ? _c("div", { staticClass: "quiz-steps" }, [
        _c(
          "div",
          { attrs: { id: "slider" } },
          [
            _c(
              "transition-group",
              { attrs: { mode: "out-in", name: "fade", tag: "ul" } },
              [
                _vm._l(_vm.questionsToShow, function (step, indexQuestion) {
                  return indexQuestion === _vm.currentIndex
                    ? _c("li", { key: indexQuestion }, [
                        _c("div", [
                          _c("div", { staticClass: "quiz-step__title" }, [
                            _vm._v(_vm._s(step.title)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "quiz-step-options" },
                            _vm._l(
                              step.options,
                              function (option, indexAnswer) {
                                return _c("div", { key: indexAnswer }, [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.nextSlide(indexAnswer + 1)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "quiz-step__link" }, [
                            _c("a", { attrs: { href: step.link } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(step.textLink) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.showAnswer
                  ? _c("li", { key: _vm.questionsToShow.length }, [
                      _vm._v("\n        Answer\n        "),
                      _vm.productAnswerInfo
                        ? _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.productAnswerInfo.images[0],
                                width: "200px",
                                alt: "Diva product",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.productAnswerInfo.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.productAnswerInfo.price)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.goToProduct(
                                      _vm.productAnswerInfo.url
                                    )
                                  },
                                },
                              },
                              [_vm._v("View product")]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("button", { on: { click: _vm.redoQuiz } }, [
                        _vm._v("Restart"),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }